<template>
  <div>
    <MainNav v-if="!is_dashboard"> </MainNav>
    <v-content>
      <v-container pa-0 fluid fill-height>
        <v-layout align-center justify-center mt-3 mb-8>
          <v-flex id="app-width" class="mt-0">
            <router-view />
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    <Footer :is_dashboard="is_dashboard"/>
  </div>
</template>


<script>
import MainNav from "@/views/MainNav"
import Footer from "@/views/Footer"
import { mapState, } from "vuex";
import homeHolderMixin from "./homeHolderMixin";

export default {
  name: 'Home',
  components: {
    MainNav,
    Footer,
  },
  mixins: [ homeHolderMixin],  
  computed:{
    ...mapState({
      is_dashboard: state => state.is_dashboard,      
    }),
  },
  created(){
    this.$store.dispatch('CLEAN_VUEX')
    this.getHomeCats()
  },  
}
</script>

<style lang="scss" scoped>
#app-width {
  max-width: 1270px;
}
</style>